$(document).ready(function() {
    $(".login_dit").hide();
    $(".login_btn_inner").click(function() {
      $(".login_btn").toggleClass("login_dit_open");
    });
    $(".header__menu-item").click(function() {
      $(".login_btn").removeClass("login_dit_open");
    });
    $(".header__icon").click(function() {
      $(".login_btn").removeClass("login_dit_open");
    });

  $(".header__icon .icon-hamburger").click(function() {
    $("body").addClass("menu_open");
  });
  $(".header__icon .icon-close").click(function() {
    $("body").removeClass("menu_open");
  });

$(".metafield-rich_text_field h4").click(function() {
  $(this).parent().toggleClass("active");
});
$(".sub_dis .sub_dis_row:first-child .metafield-rich_text_field").addClass("active");


//-------------------Size-guide-popup
$(".popup_option").click(function() {
  $(this).parents("body").find(".product_popup").addClass("popup_open");
  $("body").addClass("pro_popup_open");
});
$(".popup_closed").click(function() {
  $(this).parents("body").find(".product_popup").removeClass("popup_open");
  $("body").removeClass("pro_popup_open");
});


//-------------
$(".antwerp").addClass("active");
$(".antwerp_main_click").addClass("active");
$(".stores_antwerp_btn_col span").click(function() {
  $(".stores_antwerp_btn_col span").removeClass("active");
  $(this).addClass("active");
});
$(".antwerp").click(function() {
  $(".antwerp_main_click").addClass("active");
  $(".stores_main").removeClass("active");
});
$(".stores").click(function() {
  $(".stores_main").addClass("active");
  $(".antwerp_main_click").removeClass("active");
});
  
  
});

$(".mobile_search_menu").click(function() {
  $(this).toggleClass("search_open");
});
$("body.gradient").removeClass("overflow-hidden-tablet");


$(document).ready(function () {
  if ($(window).width() < 768) {
    $('.footer-block.grid__item ul, .social_icon_main ul').hide();
    $('.footer-block__heading, .social_icon_title').unbind().click(function () {
      $('.footer-block__heading, .social_icon_title').not($(this)).removeClass('active');
      $('.footer-block.grid__item ul, .social_icon_main ul').not($(this).siblings('.footer-block.grid__item ul, .social_icon_main ul')).slideUp();
      $(this).siblings('.footer-block.grid__item ul, .social_icon_main ul').slideToggle();
      $(this).toggleClass('active');
    });
  }
});
$(window).resize(function () {
  if ($(window).width() < 768) {
    $('.footer-block.grid__item ul, .social_icon_main ul').hide();
    $('.footer-block__heading, .social_icon_title').unbind().click(function () {
      $('.footer-block__heading, .social_icon_title').not($(this)).removeClass('active');
      $('.footer-block.grid__item ul, .social_icon_main ul').not($(this).siblings('.footer-block.grid__item ul, .social_icon_main ul')).slideUp();
      $(this).siblings('.footer-block.grid__item ul, .social_icon_main ul').slideToggle();
      $(this).toggleClass('active');
    });
  }
  else {
    $('.footer-block.grid__item ul, .social_icon_main ul').show();
  }
});

$(document).ready(function() {
  // Get the initial variant image
  var initialVariant = $('[name="id"]:checked');
  updateBackgroundImage(initialVariant);

  // Listen for variant changes
  $('[name="id"]').on('change', function() {
    updateBackgroundImage($(this));
  });

  // Function to update background image
  function updateBackgroundImage(variant) {
    var selectedVariantImage = variant.data('background-image');
    $('.product-image-container').css('background-image', 'url(' + selectedVariantImage + ')');
  }
});





  $(document).ready(function(){

    // $(".sub_dis_row .metafield-rich_text_field p").remove();
    
    $(".sub_dis_main .metafield-rich_text_field h4").click(function(){
        $(this).toggleClass("active");
    	$(this).next().toggleClass("active");
    });
    
    $(".sub_dis .sub_dis_main:first-child").addClass("active");
	$(".sub_dis_main h3").click(function(){
		$(this).parents(".sub_dis_main").toggleClass("active");
	});
  });




/* variant color */
$(document).ready(function(){
	var vals = window.location.pathname;
	console.log(vals);

	$("variant-radios label").each(function(){
	    var data = $(this).find('a[href="'+ vals +'"]').parents("label").addClass("active"); 
	    $("label.active").prev().attr("checked", true);
	});
});

//-------------------progress bar js 

// $(document).ready(function(){
//   /* range qty slider */
//   setTimeout(function() {
//     var percent = $('.current_val').attr('data-selected-var-qty');
//     var total_qty = $('.current_total').attr('data-variant_qty');
//     percent = percent * 100 / total_qty;
    
//     // total_left = parseFloat(100) - Number(percent);
//     if(percent > 100){
//       percent = 100;
//     }
//     $('.product_progressbar_block').animate({width: percent+'%' }, 2000);
//   }, 800);
//   /* range qty slider */
  
//   $('.product .single-option-radio label').click(function(){
//       var curtrent_val = $(this).attr('value');
//       $(".main_variant").removeClass('active');
//       $(".main_variant[data-value='"+ curtrent_val +"']").addClass('active');
//       var var_percent = $('.main_variant.active .variant-data.active').attr('data-selected-var-qty');
//       var var_total_qty = $('.main_variant.active .variant-data.active').attr('data-variant_qty');
//       var var_total_left = parseFloat(var_percent) - Number(var_total_qty);
//       $('.current_total').text(var_percent);
//       $('.current_val').text(var_total_left);
//       $('.product_cart_val').text(var_total_qty);
      
//       var var_percent_1 = var_total_qty * 100 / var_percent;
      
//       console.log(var_percent_1, 'var_total_left')
      
//       $('.product_progressbar_block').animate({width: var_percent_1+'%' }, 800);
//   });

//   var datas = $('input[type="radio"]:checked').val();

//   $(".main_variant").removeClass('active');
//   $(".main_variant[data-value='"+ datas +"']").addClass('active');

//   /*var qtys = $(".main_variant.active").find(".total_qty span.active").attr("qty");
//   console.log(qtys);
//   $(".current_val_main .current_val").text(qtys);*/


//   var progresss = (cart_qtys / qtys) * 100;
//   console.log(progresss);
//   $(".product_progressbar_block").css("width", progresss + "%");

//   var qty_available = qtys - cart_qtys;
//   console.log(qty_available);

//   $(".product_progressbar_count .product_cart_val").text(qty_available);
  
// });

//----------

 var swiper = new Swiper(".main_f_collection", {
    slidesPerView: 2,
    spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
    breakpoints: {
        1200: { // Desktop
            slidesPerView: 4,
            spaceBetween: 30
        },
        768: { // Tablet
            slidesPerView: 3,
            spaceBetween: 30
        },
        576: { // Mobile
            slidesPerView: 2,
            spaceBetween: 15
        },
        410: { // Mobile
            slidesPerView: 2,
            spaceBetween: 10
        }
    }
});



